import { InjectionToken } from "@angular/core";

export const DIALOG_DATA = new InjectionToken<any>('DIALOG_DATA');